import useApi from '../hook/useApi';

const useLeadsApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const refresLeads = async (status, page = 1) => {
    if (status === 'pending') {
      return sendRequest(`/imp/leads_screen/get_all_lead?status=${status}&page=${page}&randomPendingData=2`, 'GET', {});
    }
    return sendRequest(`/imp/leads_screen/get_all_lead?status=${status}&page=${page}`, 'GET', {});
  };

  const updateLeads = async (id, payload) => {
    const body = typeof payload === 'string' ? { status: payload } : payload;
    return sendRequest(`/imp/leads_screen/update_lead/${id}`, 'PUT', body);
  };

  return {
    refresLeads,
    updateLeads,
    loading,
    data,
    error,
  };
};

export default useLeadsApi;